import { render } from "./BenchmarkViewWilandDemoCta.vue?vue&type=template&id=72dfe267"
import script from "./BenchmarkViewWilandDemoCta.vue?vue&type=script&lang=js"
export * from "./BenchmarkViewWilandDemoCta.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/BenchmarkViewWilandDemoCta.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72dfe267"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72dfe267', __exports__)) {
    api.reload('72dfe267', __exports__)
  }
  
  module.hot.accept("./BenchmarkViewWilandDemoCta.vue?vue&type=template&id=72dfe267", () => {
    api.rerender('72dfe267', render)
  })

}


export default __exports__